import { classNames } from 'primereact/utils';
import { Tooltip } from 'primereact/tooltip';
import React from 'react';

type IProgressValue = {
  value: number;
  color: string;
  tooltipText?: string;
};

type StackedProgressBarProps = {
  max: number;
  values: IProgressValue[];
  isTooltip?: boolean;
  height?: string;
};

interface ProgressBarProps {
  max: number;
  index: number;
  progressValue: IProgressValue;
  isFirst?: boolean;
  isLast?: boolean;
  height?: string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  max,
  index,
  progressValue,
  isFirst,
  isLast,
  height = '1.25rem', // Default height
}) => {
  const remValue = (progressValue.value / 100) * max;

  return (
    <div
      id={`progress-bar-${index}`}
      className={classNames({
        'rounded-l': isFirst,
        'rounded-r': isLast,
      })}
      style={{
        width: `${remValue}rem`,
        backgroundColor: progressValue.color,
        height, // Gunakan height dari props
      }}
      data-pr-tooltip={progressValue.tooltipText}
      data-pr-position="top"
    />
  );
};

const tooltipStyles: React.CSSProperties = {
  backgroundColor: '#222',
  color: '#fff',
  fontSize: '0.875rem',
  fontWeight: 500,
  borderRadius: '0.375rem',
  marginTop: '-0.5rem',
  paddingBlock: '0.5rem',
  marginInline: '-0.5rem',
};

export const StackedProgressBar: React.FC<StackedProgressBarProps> = ({
  max = 25,
  values,
  isTooltip = false,
  height = '1.25rem', // Default height
}) => {
  const sanitizedValues =
    values.length > 0
      ? values
      : [{ value: 100, color: '#e0e0e0', tooltipText: 'No Data' }];

  return (
    <div className="flex flex-row">
      {sanitizedValues.map((e, index) => (
        <React.Fragment key={`progress--${e.value}`}>
          <ProgressBar
            max={max}
            index={index}
            progressValue={e}
            isFirst={index === 0}
            isLast={index === sanitizedValues.length - 1}
            height={height} // Teruskan height ke ProgressBar
          />
          {isTooltip && (
            <Tooltip target={`#progress-bar-${index}`} style={tooltipStyles} />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};
